// assets/home-scroll-guard.js
(function () {
  // ¿Es Home?
  var isHome = location.pathname === '/' || document.body.classList.contains('template-index');
  if (!isHome) return;

  // ¿Venimos desde colecciones o productos del mismo sitio?
  var fromPLPOrPDP = (function () {
    try {
      if (!document.referrer) return false;
      var u = new URL(document.referrer);
      if (u.origin !== location.origin) return false;
      return (/\/collections\//.test(u.pathname) || /\/products\//.test(u.pathname));
    } catch (e) { return false; }
  })();
  if (!fromPLPOrPDP) return;

  // Desactivar restauración automática del navegador SOLO aquí
  try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}

  function hardTop() {
    try {
      var html = document.documentElement, body = document.body;
      var prev = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      html.scrollTop = 0; body.scrollTop = 0; window.scrollTo(0, 0);
      html.style.scrollBehavior = prev || '';
    } catch(e){}
  }

  // Sujetar scroll en 0 mientras se estabiliza el layout
  function holdTop(ms) {
    var end = Date.now() + ms, stable = 0;
    (function tick(){
      if (window.scrollY > 0) { hardTop(); stable = 0; } else { stable++; }
      if (Date.now() < end && stable < 20) requestAnimationFrame(tick);
    })();
  }

  function watchMutations(durationMs) {
    var obs;
    try {
      obs = new MutationObserver(function(){
        if (window.scrollY > 0) hardTop();
      });
      obs.observe(document.documentElement, { childList:true, subtree:true, attributes:true });
      setTimeout(function(){ try{obs.disconnect();}catch(e){} }, durationMs + 200);
    } catch(e){}
  }

  function run() {
    hardTop();
    holdTop(2000);
    watchMutations(2000);
    [400, 800, 1200, 1800].forEach(function(t){ setTimeout(hardTop, t); });
  }

  run();
  document.addEventListener('DOMContentLoaded', run, { once:true });
  window.addEventListener('load', run, { once:true });
  window.addEventListener('pageshow', run, { once:true });

  // ⚠️ IMPORTANTE: aquí NO limpiamos localStorage para no afectar colecciones
})();
